import { useModelWrapper } from "@/Helpers/modelWrapper";

export const fieldProps = {
    label: {
        type: String,
        default: "",
    },
    modelValue: {
        type: [String, Number, Boolean, Array, Object],
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: String,
        default: "",
    },
    error: {
        type: String,
        default: null,
    },
    required: {
        type: Boolean,
        default: false,
    },
    autoComplete: {
        type: String,
        default: "",
    },
    sm: {
        type: Boolean,
        default: false,
    },
    lg: {
        type: Boolean,
        default: false,
    },
    xl: {
        type: Boolean,
        default: false,
    },
    info: {
        type: String,
        default: null,
    },
    flagPasteOrDrop: {
        type: Boolean,
        default: false,
    },
};

export const useFieldSetup = (props, emit) => {
    const onChange = (value) => {
        emit(`update:modelValue`, value);
    };

    const onFocus = () => {
        emit(`focus`);
    };

    const onBlur = () => {
        emit(`blur`);
    };

    return {
        inputValue: useModelWrapper(props, emit),
        onChange,
        onFocus,
        onBlur,
    };
};
